
import React, { useContext, useEffect, useState } from 'react'
import ModalCover, { ModalCoverProps } from '../../modalCover/ModalCover'
import { RootState } from '../../../../core/store/store';
import { ActionBarOptions } from '../interfaces';
import { hideActionBar, resetCurrentPageActionBar } from '../actions/actionBar-action';
import { useDispatch, useSelector } from "react-redux";
import { useUser } from '../../../../core/hooks/db/user/useUser';
import { TableNamesType } from '../../../../core/interfaces/table-name-type';
import { AxiosResponse } from 'axios';
import { LoaderContext } from '../../../components/loader/context/LoaderContext';
import { useActionBarStore } from '../../../../core/store';
import { User } from '../../../../core/models/db';


interface DeleteModalProps {
    table: TableNamesType;
    items: any[],
    handleModal: (value?: boolean) => void;


    // interface ModalCover
    count?: number;
    show?: any;
    children?: any;
    title?: any;
    hasCloseButton?: any;
    hasSuccessButton?: any;
    hasCloseHeaderButton?: any;

}

const UserBlockedModal = (props: DeleteModalProps) => {
    const {
        table,
        handleModal,
        items,

        // interface ModalCover
        count,
        show,
        children,
        title,
        hasCloseButton = true,
        hasSuccessButton = false,
        hasCloseHeaderButton = true,

    } = props;


    const { updateUser } = useUser()





    const { resetPageActionBar } = useActionBarStore(state => state)

    const dispatch = useDispatch();

    const [fn, setFn] =
        useState<({ isBlocked }: User) => Promise<AxiosResponse<any, any>> | null>(null);
    const [hasError, setHasError] = useState(false);
    const [labels, setLabels] = useState<{
        labelSigle: string,
        labelMany: string,
        titleModal: string
    }>({
        labelMany: "¿Quieres cambiar de estado los usuarios?",
        labelSigle: "¿Quieres cambiar el estado del usuario elegido?",
        titleModal: "Modificar el estado del usuario"
    });

    const { handleLoading } = useContext(LoaderContext);



    useEffect(() => {
        if (!fn) {
            switch (table) {
                case "user":
                    setLabels({
                        labelMany: "¿Quieres cambiar de estado los usuarios?",
                        labelSigle: "¿Quieres cambiar el estado del usuario elegido?",
                        titleModal: "Modificar el estado del usuario"
                    })
                    setFn(({ isBlocked }: User) => updateUser({ isBlocked }, 'someId'));
                    break;

                default:
                    setHasError(true);
                    console.error("Mal uso del modal DELETE. Tabla recibida", table)
            }
        }
    }, [table])


    const successButton = async () => {

        try {
            handleLoading(true);

            console.warn("HAY QUE CREAR UNA FUNCIÓN PARA CAMBIAR EL ESTADO DE VARIOS USUARIOS")
            console.warn("Se ha de comprobar que todos los usuarios señalados tienen el mismo estado, en caso contrario no poder hacer la acción")
            debugger;
            // let result = await fn(items, true)
            // console.log("[Modal Delete] - result is...", result)
        } catch (e) {
            console.error(e)
        } finally {
            handleModal(false);
            setTimeout(() => {
                resetPageActionBar();
                dispatch(resetCurrentPageActionBar());
            }, 100)
        }
    }

    return (
        <ModalCover
            styleHeader={{ fontSize: '1.5rem' }}
            show={!hasError ? show : false}

            title={labels.titleModal}
            hasCloseButton={true}
            hasSuccessButton={true}

            handleModal={handleModal}
            fnSuccess={successButton}
        >
            <div className=''>
                {count > 1
                    ? (
                        <span>{labels.labelMany}</span>
                    )
                    : (
                        <span>{labels.labelSigle}</span>
                    )
                }
            </div>
        </ModalCover>
    )
}

export default UserBlockedModal

